<template>
  <div class="dol-multiple-input">
    <a-button @click="add" v-if="maxLength?value.length<maxLength:true">
      <a-icon type="plus" /> 添加
    </a-button>
    <a-row v-for="(item, index) in value" :key="index">
      <a-col :span="23">
        <slot :item="item" :index="index">
          <a-input :value="item" :placeholder="placeholder" @input="v => change(v, index)" />
        </slot>
      </a-col>
      <a-col :span="1" class="text-center">
        <a-button shape="circle" @click="remove(index)" v-if="minLength?value.length>minLength:true">
          <a-icon type="delete" />
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  export default {
    name: 'dol-multiple-input',
    props: {
      value: {type: Array, default:() => []},
      placeholder: {},                            //placeholder
      minLength: {},                              //最小长度
      maxLength: {},                              //最大长度
      type: {type: String, default: 'string'},    //元素数据类型
    },
    data: function () {
      let params = {
      };
      return params;
    },
    computed: {
    },
    methods: {
      change(value, index){
        let _value = this.value.concat();
        _value[index] = value;
        this.$emit('input', _value);
      },
      add(){
        let newValue = this.value.concat();
        switch (this.type) {
          case 'string': newValue.push(''); break;
          case 'object': newValue.push({}); break;
        }

        this.$emit('input', newValue);
      },
      remove(index){
        let newValue = this.value.concat();
        newValue.splice(index, 1);
        this.$emit('input', newValue);
      },
    },

    created: function () {
      if (this.minLength) {
        let newValue = this.value.concat();
        while (newValue.length < this.minLength) {
          newValue.push([]);
        }
        this.$emit('input', newValue);
      }
    }
  }
</script>
